import styled from "@emotion/styled";

import { Button } from "@livechat/design-system";

export const StyledButton = styled(Button)`
  height: 24px;
  margin-top: -6px;
  font-size: 14px;
  min-height: 0;
`;

export const LinkBox = styled.div`
  .down-arrow {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    margin-left: 8px;
    margin-right: 8px;
    position: relative;
    top: 1px;
    border-top: 4px solid
      ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.linkColor
      };
  }
`;

export const ModalBlock = styled.div`
  font-size: 15px;
  padding: 20px;
  line-height: 1.34;

  max-width: 560px;

  @media (max-width: 400px) {
    font-size: 14px;
    padding: 10px;
  }

  p {
    margin-bottom: 16px;
  }
`;
